var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M819.2 140.8v-102.4c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48v102.4h-523.997l-116.882-116.882c-7.998-7.998-20.965-7.998-28.963 0s-7.998 20.965 0 28.963l116.882 116.882v360.157c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48v-319.197l483.037 483.037h-626.397c-11.311 0-20.48 9.169-20.48 20.48s9.169 20.48 20.48 20.48h102.4v102.4c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48v-102.4h523.997l116.882 116.882c7.998 7.998 20.965 7.998 28.963 0s7.998-20.965 0-28.963l-116.882-116.882v-360.157c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48v319.197l-483.037-483.037h626.397c11.311 0 20.48-9.169 20.48-20.48s-9.169-20.48-20.48-20.48h-102.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.1212f78996d61fbfea5311d87309cdee.svg";
export { ForwardRef as ReactComponent };